import { render, staticRenderFns } from "./real-estate-parameter.vue?vue&type=template&id=1f9bb8c5&scoped=true&"
import script from "./real-estate-parameter.vue?vue&type=script&lang=js&"
export * from "./real-estate-parameter.vue?vue&type=script&lang=js&"
import style0 from "./real-estate-parameter.vue?vue&type=style&index=0&id=1f9bb8c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9bb8c5",
  null
  
)

export default component.exports